(() => {
  class KitSelectorCard {
    constructor(card) {
      this.card = card;
      this.swatches = [...card.querySelectorAll('[data-swatch]')];
      this.variantInput = card.querySelector('[data-kit-variant-input]');
      this.submitBtn = card.querySelector('.kit-selector__btn');
      this.cardImg = card.querySelector('.kit-selector__image-wrap img');
      this.priceEl = card.querySelector('[data-price]');
    }

    init() {
      const selected = this.card.querySelector('[data-swatch].is-selected');
      if (selected?.dataset.variantImage && this.cardImg) {
        this.cardImg.src = selected.dataset.variantImage;
      }
      if (selected) this.updateAlt(selected);
      this.swatches.forEach((swatch) => {
        swatch.addEventListener('click', this.onSwatchClick);
      });
    }

    updateAlt(swatch) {
      const template = this.cardImg?.dataset.altTemplate;
      const color = swatch.dataset.colorLabel;
      if (!template || !color || !template.includes('{color}')) return;
      this.cardImg.alt = template.replace('{color}', color);
    }

    onSwatchClick = (event) => {
      this.select(event.currentTarget);
    };

    select(swatch) {
      this.swatches.forEach((other) => {
        other.classList.remove('is-selected');
        other.setAttribute('aria-pressed', 'false');
      });
      swatch.classList.add('is-selected');
      swatch.setAttribute('aria-pressed', 'true');

      if (this.cardImg && swatch.dataset.variantImage) {
        this.cardImg.src = swatch.dataset.variantImage;
      }
      this.updateAlt(swatch);

      if (this.variantInput) this.variantInput.value = swatch.dataset.variantId;

      if (this.priceEl && swatch.dataset.variantPriceFormatted) {
        this.priceEl.textContent =
          swatch.dataset.variantPriceFormatted + (this.priceEl.dataset.priceSuffix ?? '');
      }

      if (this.submitBtn) {
        const available = swatch.dataset.variantAvailable === 'true';
        this.submitBtn.disabled = !available;
        const label = this.submitBtn.querySelector('span');
        if (label) {
          label.textContent = available
            ? this.submitBtn.dataset.textAvailable
            : this.submitBtn.dataset.textSoldout;
        }
      }
    }
  }

  const initKitSelectorCards = (root = document) => {
    root.querySelectorAll('.kit-selector [data-card]').forEach((card) => {
      if (card.dataset.kitSelectorReady) return;
      card.dataset.kitSelectorReady = 'true';
      new KitSelectorCard(card).init();
    });
  };

  initKitSelectorCards();
  document.addEventListener('shopify:section:load', (event) => initKitSelectorCards(event.target));
})();
